import engineering from '../assets/images/engineering.png';
import service from '../assets/images/service-maintenance.png';
import equipment from '../assets/images/equipment-supply.png';
import ourStorage from '../assets/video/Storage.mp4';
import storageService from '../assets/images/storage-service.png'

import orangeBg from '../assets/images/orange-bg.png';
import blueBg from '../assets/images/blue-bg.png';

export const services = [ {
  thumbnail : engineering,
  title     : 'Проектирование',
  desc      : 'Наша компания может разработать проектно-сметную документацию по разделам «Отопление, вентиляция и кондиционирование», «Внутренние водопровод и канализация», «Котельные. Тепломеханическая часть». Мы имеем в штате высококвалифицированных инженеров-проектировщиков, что позволяет нам уверенно браться за объекты любой сложности.',
  background: blueBg,
  src       : ''
}, {
  thumbnail : equipment,
  title     : 'Поставка оборудования',
  desc      : 'Мы занимаемся поставкой полного спектра оборудования для систем отопления, вентиляции и кондиционирования от ведущих мировых производителей. Все оборудование соответствует высокими требованиями мировых стандартов качества и сопровождается при поставке полным комплектом необходимых документов.',
  background: orangeBg,
  src       : ''
}, {
  thumbnail : service,
  title     : 'Монтаж и сервисное обслуживание',
  desc      : 'Everest Building Group предоставляет полный спектр услуг по монтажным работам в сфере отопления, вентиляции, кондиционирования, водоснабжения, водоотведения и котельных блоков, а также квалифицированное сервисное обслуживание – контроль над основными параметрами работоспособности, осуществляемый с определенной периодичностью, чтобы система продолжала функционировать безотказно.',
  background: blueBg,
  src       : ''
}, {
  thumbnail : storageService,
  title     : 'Склад продовольственных продуктов',
  desc      : 'Рады представить Вам склад для хранения продовольственных продуктов Balton Traiding Asia, который оснащен самыми передовыми технологиями. Более детальная информация по нашему складу предоставлена в видео-ролике',
  background: orangeBg,
  src       : ourStorage
} ];